export default __webpack_public_path__ + "static/media/linux.d50294a2.png";